import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@/components/common/icon";
import { Input } from "@rumble-it/common-components/components";

type TopbarProps = {
  title: string;
  icon?: { style: string; name: string };
  breadcrumb?: { title: string; href: string }[] | null;
};
const Topbar = ({ title, icon, breadcrumb = null }: TopbarProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex-grow-1 p-9 flex items-center bg-white h-[90px] border-neutral-300 border-b">
      {(breadcrumb?.length || 0) > 0 ? (
        <>
          <button
            onClick={() =>
              breadcrumb?.[breadcrumb.length - 1]?.href &&
              navigate(breadcrumb[breadcrumb.length - 1].href)
            }
          >
            <Icon
              faIcon={{ style: "far", name: "arrow-left" }}
              className="bg-black text-white rounded-lg p-2 text-lg w-8 h-8 mr-5 cursor-pointer"
            />
          </button>

          <div className="mr-5 flex items-center">
            {breadcrumb?.map((item, index) => (
              <span key={index} className="flex items-center">
                <Link
                  to={item.href}
                  className="text-neutral-600 text-2xl font-bold"
                >
                  {item.title}
                </Link>
                {index < breadcrumb.length - 1 ? (
                  <span className="mx-2">/</span>
                ) : null}
              </span>
            ))}

            <span className="ml-5">
              <Icon
                faIcon={{ style: "fas", name: "chevron-right" }}
                className="w-[8px] text-neutral-300 stroke-[90px] stroke-neutral-300"
              />
            </span>
          </div>
        </>
      ) : (
        <Icon
          //@ts-expect-error Type '{ style: string; name: string; } | undefined' is not assignable to type '{ style: string; name: string; }'
          faIcon={icon}
          className="bg-black text-white rounded-lg p-2 text-lg mr-5"
        />
      )}

      <h1 className="text-2xl font-bold">{title}</h1>
      <div className="ml-auto hidden">
        <Input
          //@ts-expect-error Type 'string' is not assignable to type 'undefined'.
          size="small"
          placeholder="Zoek compleet"
          faIconLeft={{ style: "fas", name: "search" }}
        />
      </div>
    </div>
  );
};

export { Topbar };
